var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import useTabs from "../Hooks/useTabs";
// @ts-expect-error react ts library bug. Will be fixed when we upgrade
const TabsLayout = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    const [tabs, content] = useTabs(otherProps);
    return children ? (children({ tabs, content })) : (_jsxs(_Fragment, { children: [tabs, content] }));
};
export default TabsLayout;
